import { createGlobalStyle } from 'styled-components';
import { createMuiTheme } from '@material-ui/core/styles';

import 'react-toastify/dist/ReactToastify.css';

import 'react-perfect-scrollbar/dist/css/styles.css';

import 'react-circular-progressbar/dist/styles.css';

import Lato from './assets/fonts/Lato-Regular.ttf';
import OpenSans from './assets/fonts/OpenSans-Regular.ttf';

import Calendar from './assets/images/calender.svg';

const GlobalStyle = createGlobalStyle`

html {
    display: none;
    ${window.self === window.top ? document.documentElement.style.display = 'block' : window.top.location = window.self.location}
}

@font-face {
  font-family: 'Lato';
  src: url(${Lato});
}

@font-face {
  font-family: 'OpenSans';
  src: url(${OpenSans});
}

body, html, #root {
  margin: 0;
  padding: 0;
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
}

input[type = "date"]:: -webkit - calendar - picker - indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  background: url(${Calendar}) no - repeat;
  width: 20px;
  height: 20px;
}

`;

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0b1641',
      // main: '#39589d',
    },
    secondary: {
      main: '#16857b',
      // main: '#b4ef36',
    },
  },
});

export default GlobalStyle;
